/**
 * The API exposes related resources and resources themselves as IRIs
 * (e.g. "/api/exit_notes/12"). This returns the trailing identifier so it can be
 * used on its own, or null when the relation is absent.
 */
export const getIdFromIri = (iri?: string | null): string | null => {
  if (!iri || typeof iri !== "string") {
    return null;
  }

  const id = iri.split("/").filter(Boolean).pop();

  return id ?? null;
};

/**
 * Rows are identified by their numeric id; the "@id" IRI is used as a fallback,
 * like the other list pages of the app.
 */
export const getRowId = (row: any): string | null =>
  getIdFromIri(row?.["@id"]) ?? (row?.id != null ? String(row.id) : null);
